var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostToCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "post_to_community_prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#post_to_community_prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.831 14.137l3.252-11.293q.288-1.002-.456-1.732-.743-.731-1.74-.425L2.078 4.005Q1.015 4.332.86 5.433q-.156 1.102.776 1.71l2.523 1.648-.44 2.204q-.087.441.198.788.285.348.734.348h2.49l1.524 2.447q.288.462.777.677.453.2.95.13.496-.069.878-.384.411-.34.562-.864zm.408-11.682L7.668 7.283a.75.75 0 00.014 1.046l.001.001.013.013a.75.75 0 001.047-.014l.014-.015 4.583-4.84-2.95 10.247q-.045.157-.206.179-.161.022-.247-.116l-1.964-3.153H5.32l.506-2.542-3.372-2.202q-.133-.087-.11-.244.022-.157.173-.204l9.721-2.984z",
    fillRule: "evenodd",
    fill: "#2B2B2B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostToCommunity);
export default __webpack_public_path__ + "static/media/post_to_community.c71a6113.svg";
export { ForwardRef as ReactComponent };